import React, { useCallback } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import WeekHeader from './components/WeekHeader';
import WeekCardsList from './components/WeekCardsList';
import { ModuleProps } from 'types';
import useKeyLessonPreview from '../hooks/use-key-lesson-preview';
import { useHistory } from 'react-router-dom';
import { getLessonPlanDataByWeek } from '../util/lesson-plan-util';
import { LessonPreviewWeekData } from '../types';
import PreviewListContainer from '../components/PreviewListContainer';

const useStyles = makeStyles((theme: Theme) => {
  return {
    headerContainer: {
      padding: theme.spacing(4),
      paddingBottom: theme.spacing(1)
    }
  };
});

const WeeksLessonPreview: React.FC<ModuleProps> = props => {
  const classes = useStyles();
  const history = useHistory();
  const { data, productCurriculumCode, resourceTypeId, week } = useKeyLessonPreview();
  const buildWeekLessonPlanData: () => LessonPreviewWeekData | undefined = useCallback(() => {
    return getLessonPlanDataByWeek(data as any, Number(week));
  }, [data, week]);

  const lessonPlanData = buildWeekLessonPlanData();

  const handleWeekChange = (value: number): void => {
    let nextWeek = Number(week) + value;

    if (nextWeek < 1) nextWeek = data.length;
    else if (nextWeek > data.length) nextWeek = 1;

    history.push(`/resources/${resourceTypeId}/${productCurriculumCode}/${nextWeek}`);
  };

  const handleNavigateToWeeksView = (): void => {
    history.push(`/resources/${resourceTypeId}/${productCurriculumCode}`);
  };

  return (
    <PreviewListContainer {...props}>
      <div className={classes.headerContainer}>
        <WeekHeader
          week={week}
          theme={lessonPlanData?.theme}
          keys={lessonPlanData?.keys}
          thumbnail={lessonPlanData?.theme?.icon}
          onWeekChange={handleWeekChange}
          onNavigateToWeeksView={handleNavigateToWeeksView}
        />
      </div>
      <WeekCardsList data={lessonPlanData} />
    </PreviewListContainer>
  );
};

export default WeeksLessonPreview;
